<script setup lang="ts">
import { debounce } from "es-toolkit";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toastification";

import CardVue from "@/common/components/card/CardVue.vue";
import BaseIcon from "@/common/components/icons/BaseIcon.vue";
import PageWrapper from "@/common/components/PageWrapper.vue";
import { useRealTimeScanning } from "@/fabricks/chips/composables/useRealTimeScanning";

definePage({
  meta: {
    auth: ["FabricksAdmin.Access"],
  },
});

const toast = useToast();
const router = useRouter();
const chipScannedEvent = useRealTimeScanning();

const isLoading = ref(false);
const debouncedChipScannedCallback = debounce(async () => {
  if (!chipScannedEvent.value?.orderId) {
    toast.warning("No order", { timeout: 5000 });

    return;
  }

  router.push(`/orders/${chipScannedEvent.value.orderId}/chip-scan`);
}, 500);

watch(chipScannedEvent, debouncedChipScannedCallback, { immediate: false });

const breadcrumbLinks = [
  {
    label: "Find Order (NFC)",
    to: "#",
  },
];
</script>

<template>
  <PageWrapper
    :is-pending="isLoading"
    title="Find Order (NFC)"
    :breadcrumb-links="breadcrumbLinks"
  >
    <CardVue>
      <div class="flex flex-col gap-4 w-full items-center justify-center">
        <BaseIcon
          name="heroicons:wifi"
          class="text-gray-300 size-20"
        />

        <p class="text-gray-500">
          Please scan an NFC chip to display order details
        </p>
      </div>
    </CardVue>
  </PageWrapper>
</template>
